<template>
  <vv-box :title="title">
    <vv-single-tip v-for="tip in tips" :key="tip.id" :label="tip" />
  </vv-box>
</template>

<script>
import { VvBox } from './'
import VvSingleTip from './VvSingleTip'

export default {
  name: 'VvTips',
  props: {
    title: String,
    tips: Array
  },
  components: {
    VvBox,
    VvSingleTip
  }
}
</script>

<style lang="scss" scoped>
</style>
